/** *
 * 基本设置
 */
import Main from '@components/main/main'

const basicSet = {
  path: '/basicSet',
  component: Main,
  redirect: '/basicSet/basicInfoDetail',
  children: [{
    name: 'basicInfoDetail',
    path: '/basicSet/basicInfoDetail',
    component: () => import('@pages/baseInfoSet/pages/basicInfoDetail'),
    meta: {
      auth: true,
      title: '基本设置'
    }
  }]
}

export default basicSet



// WEBPACK FOOTER //
// ./src/pages/baseInfoSet/index.js